import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'components';

const FilterDropdown = ({ options, selected, onChange, arrowColor }) => (
  <Dropdown
    options={options}
    selected={selected}
    onSelect={onChange}
    arrowColor={arrowColor}
  />
);
FilterDropdown.propTypes = {
  filter: PropTypes.string,
  middleware: PropTypes.string,
  defaultValue: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  arrowColor: PropTypes.string,
};
export default FilterDropdown;



// WEBPACK FOOTER //
// ./src/components/molecules/FilterDropdown/index.js